var _defs, _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-589.5 -136.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(589.5 137.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M608.352,151.6H597.2a.492.492,0,1,1,0-.984h11.148a.166.166,0,0,0,.164-.164v-11.8a.166.166,0,0,0-.164-.164h-17.7a.166.166,0,0,0-.164.164v11.8a.166.166,0,0,0,.164.164h3.279a.492.492,0,1,1,0,.984h-3.279a1.149,1.149,0,0,1-1.148-1.148v-11.8a1.149,1.149,0,0,1,1.148-1.148h17.7a1.149,1.149,0,0,1,1.148,1.148v11.8A1.149,1.149,0,0,1,608.352,151.6Z",
    transform: "translate(-589.5 -137.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(593.107 141.434)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M612.8,150.484h-11.8a.492.492,0,1,1,0-.984h11.8a.492.492,0,1,1,0,.984Z",
    transform: "translate(-600.5 -149.5)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(593.107 144.057)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M612.8,158.484h-11.8a.492.492,0,1,1,0-.984h11.8a.492.492,0,1,1,0,.984Z",
    transform: "translate(-600.5 -157.5)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(593.107 146.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M608.861,166.484h-7.869a.492.492,0,1,1,0-.984h7.869a.492.492,0,0,1,0,.984Z",
    transform: "translate(-600.5 -165.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(593.434 150.615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M601.992,182.418a.491.491,0,0,1-.492-.492v-3.934a.492.492,0,0,1,.984,0v2.576l2.409-2.891a.492.492,0,1,1,.755.63l-3.279,3.934A.491.491,0,0,1,601.992,182.418Z",
    transform: "translate(-601.5 -177.5)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/SMS.d49846aa7d0a82152bd4ff079722564f.svg";
export { ForwardRef as ReactComponent };